import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
const Root = styled.hr.withConfig({
  displayName: "DropdownDivider__Root",
  componentId: "sc-lopmvk-0"
})(["height:1px;border:none;background-color:var(--neutral-border);margin:var(--size-spacing-01) 0;"]);
const DropdownDivider = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(Root, _extends({}, props, {
    ref: ref
  }));
});
DropdownDivider.Style = Root;
DropdownDivider.displayName = 'DropdownDivider';
export default DropdownDivider;